import { errorKind } from './errors'

/**
 * How many times a failed query is retried, by kind of failure:
 * - network / unavailable → 3 (no answer from the backend: it may be
 *   restarting, or the tunnel is down);
 * - 429 → 2;
 * - 5xx the backend answered, 401 (Clerk refreshes the token on the second
 *   try) and anything unclassified (our own ``Error``s, bugs) → 1, the
 *   ``retry: 1`` this replaced;
 * - the other 4xx and clock skew → 0, a retry wouldn't change them.
 */
export function retryLimit(err: unknown): number {
  switch (errorKind(err)) {
    case 'network':
    case 'unavailable':
      return 3
    case 'rate_limit':
      return 2
    case 'server':
    case 'auth':
    case 'unknown':
      return 1
    default:
      return 0
  }
}

/** ``retry`` option for TanStack Query: ``failureCount`` starts at 0. */
export function queryRetry(failureCount: number, err: unknown): boolean {
  return failureCount < retryLimit(err)
}

/** Exponential backoff, 1 s → 2 s → 4 s, capped at 8 s. */
export function queryRetryDelay(attempt: number): number {
  return Math.min(1000 * 2 ** attempt, 8000)
}
